<template>
    <div class="logo-header" @click="safeDigest">
        <router-link to="/">
            <IconBase width="127" height="32" :iconColor="consts.COLORS.WHITE" key="companyLogoIcon"
                      iconName="companyLogoIcon" class="logo-position" v-if="isMenuOpen">
            </IconBase>
            <IconBase width="32" height="32" :iconColor="consts.COLORS.WHITE" key="isLogoIcon"
                      iconName="isLogoIcon" class="logo-position" v-else>
            </IconBase>
        </router-link>
    </div>
</template>

<script>
import IconBase from 'components/IconBase.vue';
import consts from 'services/metaData/consts';
import { safeDigest } from 'services/utils/angularUtils';

export default {
    name: 'Logo',
    components: { IconBase },
    data() {
        return {
            consts
        };
    },
    methods: {
        safeDigest() {
            this.$nextTick().then(() => {
                safeDigest();
            });
        }
    },
    props: {
        isMenuOpen: Boolean
    }
};
</script>

<style scoped lang="scss">
@import "../common";

.logo-header{
    height: $calculatedHeaderHeight;
    background-color: $headerColor;
    position: relative;
    overflow: hidden;
    cursor: pointer;

    @media #{$laptop} {
        height: $calculatedHeaderHeightMiniMode;
    }

    @media #{$tablet} {
        height: $calculatedHeaderHeightTitleMode;
    }

    @media #{$mobile} {
        display: none;
    }
}
.logo-position {
    position: absolute;
    bottom: 15px;
    left: 18px;
    height: 32px;
}

</style>
